import parse from 'date-fns/parse'

const addSignBeforeTimezone = (value: number): string => {
  return (value < 0 ? '-' : '+') + (Math.abs(value) < 10 ? '0' : '') + value.toString()
}

export const parseDate = (date: string) => parse(date, 'dd/MM/yyyy', new Date())
export const parseDateTime = (date: string, timezone: number = 0) => {
  const timezoneString = addSignBeforeTimezone(timezone)
  return parse(`${date} ${timezoneString}`, 'dd/MM/yyyy HH:mm x', new Date())
}
